// Module
var code = "<template>\n    <require from=\"./../net/net-list\"></require>    \n    <net-list if.bind=\"params.Id\" context=\"customer-list\" params.bind=\"params\" customerid.bind=\"params.Id\"></net-list>\n</template> ";
// Exports
export default code;